<div [formGroup]="formGroup">
  <cap-checkbox [label]="'general.yes' | translate" formControlName="answer_boolean"></cap-checkbox>
</div>
